import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AuthenticationService } from './authentication.service';
import { LoginComponent } from './login.component';
import { AuthenticationEffects } from './state/authentication.effects';
import { AuthenticationReducer, STORE_FEATURE_KEY_AUTHENTICATE } from './state/authentication.reducer';
import { AuthenticationSelectors } from './state/authentication.selectors';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(STORE_FEATURE_KEY_AUTHENTICATE, AuthenticationReducer),
        EffectsModule.forFeature([AuthenticationEffects]),
        ReactiveFormsModule
    ],
    declarations: [
        LoginComponent
    ],
    providers: [
        AuthenticationService,
        AuthenticationSelectors
        ]
})
export class AuthenticationModule {

}
